import * as service from "@/views/statement/services/index.js";

export default {
    state: {
        curLanguage: "", // 当前话术仓库类型
        selectedType: "", // 当前选中的话术库类型
        stmtTypeList: [],
        total: 0
    },
    mutations: {
        updateCurLanguage(state, payload) {
            state.curLanguage = payload;
        },
        updateSelectedType(state, payload) {
            state.selectedType = payload;
        },
        updateStmtTypeList(state, payload) {
            state.stmtTypeList = payload.list || [];
            state.total = payload.count;
        }
    },
    actions: {
        async queryStmtTypeList({ state, commit }) {
            let data = await service.getStatementTypeList(state.curLanguage);
            commit("updateStmtTypeList", data);
        },
        addStmtType({ dispatch }, params) {
            service.addStatementType(params).then(() => {
                dispatch("queryStmtTypeList");
            });
        },
        updateStmtType({ state, dispatch }, params = {}) {
            let stmtType = state.stmtTypeList.find(type => type.id === params.type_id);
            service.updateStatementType({ ...params, language: stmtType.language }).then(() => {
                dispatch("queryStmtTypeList");
            });
        },
        deleteStmtType({ dispatch }, params) {
            service.deleteStatementType(params).then(() => {
                dispatch("queryStmtTypeList");
            });
        }
    }
};
